'use strict';

module.exports = {
  planningHub: 'planning-hub',
  spaceTest: 'space-test',
  retailDataPlatform: 'retail-data-platform',
};
